import { DINEIN_TYPE } from '../webStorage/keys/sessionKeys';

export const checkIfAlreadyRunningDineInOrder = (cartToCheck, restaurant_id) => {
  let result = { showTableChange: false, oldTable: '', oldTableId: '', dineInOrderId: '' };
  if (cartToCheck?.order && Array.isArray(cartToCheck.order)) {
    const allOrders = cartToCheck.order;
    for (let i = 0; i < allOrders.length; i++) {
      if (
        allOrders[i].order_type === +DINEIN_TYPE &&
        allOrders[i].restaurant_id === restaurant_id &&
        allOrders[i].table_changed_by != 'staff'
      ) {
        result['showTableChange'] = true;
        result['oldTable'] = allOrders[i].table_no;
        result['oldTableId'] = allOrders[i].table_id;
        result['dineInOrderId'] = allOrders[i].order_id;
        break;
      }
    }
  }
  return result;
};
